



var cursor = document.querySelector('.cursorBlob');
var careerSliderSection = document.querySelector('.careerSliderSection');

careerSliderSection.addEventListener('mousemove', function(e){

    var crx = e.clientX;

    var cry = e.clientY;

    cursor.style.transform = `translate3d(calc(${e.clientX}px - 50%), calc(${e.clientY}px - 50%), 0)`

});






/* GSAP */



gsap.registerPlugin(ScrollTrigger);

let mm = gsap.matchMedia();

mm.add("(min-width: 767.98px)", () => {

  ScrollTrigger.normalizeScroll(true);

});



//document.addEventListener("DOMContentLoaded", (event) => {

   

    const VW = Math.max(document.documentElement.clientWidth, window.innerWidth),

            VH = Math.max(document.documentElement.clientHeight, window.innerHeight);



    let svgns = "http://www.w3.org/2000/svg",

    container = document.getElementById("blobs-g");

    for (let count = 1; count <= 10; count++) {

        let x = Math.floor(Math.random() * VW),

            y = Math.floor(Math.random() * VH),

            size = Math.floor(Math.random() * 2) * 2 + 150;

            

        var circle = document.createElementNS(svgns, "circle");

        circle.setAttributeNS(null, "class", "blob");

        circle.setAttributeNS(null, "id", `blob-${count}`);

        circle.setAttributeNS(null, "cx", x);

        circle.setAttributeNS(null, "cy", y);

        circle.setAttributeNS(null, "r", size);

        container.appendChild(circle);



        gsap.to(`#blob-${count}`, {

            x: `random(${0 - x}, ${VW - x})`,

            y: `random(${0 - y}, ${VH + y})`,

            duration: `random(1, 10)`,

            //opacity:`random(0, 1)`,

            scale:`random(0, 1)`,

            repeat: -1,

            repeatRefresh: true

        });



    }




